import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { selectPaymentUrl } from "../loans/ducks";
import { cardPaymentActions } from "../loans/ducks";
import { createQueryString } from "../../common/utils/helpers";
import queryString from 'query-string';
import { Spin } from "antd";

const mapStateToProps = state => ({
    paymentUrl: selectPaymentUrl(state)
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
      {
        cardPayment: cardPaymentActions.request

      },
      dispatch
    )
});

@connect(mapStateToProps, mapDispatchToProps)
export default class MailCardPayment extends Component {

    state = {
        payment: false,
        isLoading: true 
    }
    

    componentDidMount(){

        const script = document.createElement("script");
        script.src = "https://amapi.trustpay.eu/mapi5/Scripts/TrustPay/popup.js";
        script.async = true;
        document.body.appendChild(script);

        const { actions } = this.props
        console.log()
        console.log(this.props.location.query.AM)
        actions.cardPayment({loanId: this.props.location.query.Loan, data: {amount: this.props.location.query.AM}})
        this.setState({
            payment: true,
            isLoading: false
        })
    }

    hideSpinner = () => {
        window["openPopup"]()
        this.setState({
            isLoading: false
        });
    }
    render() {
        const { paymentUrl } = this.props
        return (
            <div>
                {this.state.loading ? (

                <Spin spinning={this.state.isLoading}>

                </Spin>

                ) : null}
                <iframe id="TrustPayFrame" allow="payment" src={paymentUrl} onLoad={this.hideSpinner}
                style={{position: 'fixed', inset: 0+'px', width: 100+'%', height: 100 + '%', border: 'none', opacity: 1, transitionDelay: 0.5+'s', zIndex: 99999}}>
                </iframe>
            </div>
            
        )
    }
}


// WEBPACK FOOTER //
// ./src/features/pages/MailCardPayment.js